/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Delete_Toast_Bulk_Error_TitleInputs */

const es_sidebar_delete_toast_bulk_error_title = /** @type {(inputs: Sidebar_Delete_Toast_Bulk_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar chats`)
};

const en_sidebar_delete_toast_bulk_error_title = /** @type {(inputs: Sidebar_Delete_Toast_Bulk_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete chats`)
};

/**
* | output |
* | --- |
* | "Failed to delete chats" |
*
* @param {Sidebar_Delete_Toast_Bulk_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_toast_bulk_error_title = /** @type {((inputs?: Sidebar_Delete_Toast_Bulk_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Toast_Bulk_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_toast_bulk_error_title(inputs)
	return en_sidebar_delete_toast_bulk_error_title(inputs)
});
export { sidebar_delete_toast_bulk_error_title as "sidebar.delete_toast.bulk_error_title" }